module.exports = __webpack_public_path__ + "img/4e129961ceac7ac3715b928fa43fcaf3.png";